export default {
  data: 'data',
  fetchId: 'fetchId',
  meta: 'meta',
  name: 'analyticsDashboard',
  notification: 'notification',
  query: 'query',
  visualization: 'visualization'
};
